import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Paper, useMediaQuery, Divider, List, ListItemButton, Typography, Grid, Breadcrumbs, useTheme } from '@mui/material';
import AllTab from './Alltab';
import InterestedTab from './Interestedtab';
import SubmittedTab from './Submittedtab';
import InterviewsTab from './Interviewstab';
import NotesTab from './Notestab';
import StatusTab from './StatusTab';
import { useDispatch, useSelector } from 'react-redux';
import { appSelector } from '../redux/selector';
import { getCandidateDetailAction, selectedJobAction } from '../redux/action';
import { userSelector } from '../user-redux/selector'
import { useLocation } from 'react-router-dom';


const Candidatejobs = () => {
  const dispatch = useDispatch()
  const { primaryResumeDetails } = useSelector(appSelector)
  const { user } = useSelector(userSelector)
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showJobDetails, setShowJobDetails] = useState(true); //
  const location = useLocation();

  const theme = useTheme();
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs")); // Very small mobile devices
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "sm")); // Regular mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets
  const isDesktop = useMediaQuery(theme.breakpoints.up("md")); // Desktops and larger
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg")); // Small desktops
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops

  useEffect(() => {
    if (!user?.candidate_id) return;
    dispatch(getCandidateDetailAction(user.candidate_id));
  }, [user?.candidate_id, dispatch]);

  // Check for the state passed during navigation and set the selectedTab
  useEffect(() => {
    if (location.state?.selectedTab !== undefined) {
      setSelectedTab(location.state.selectedTab);
    } else if (location.state?.selectedJobId) {
      setSelectedTab(0); // All tab when opening a specific job from dashboard
    }
  }, [location]);
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    // Reset All-tab Redux selection so Interested/other tabs don't leak into All,
    // and All details go back to loading until its own list selects a job.
    if (newValue === 0) {
      dispatch(selectedJobAction(null));
    }
  };

  const tabComponents = [
    <AllTab onSelectJob={setSelectedJob} />,
    <InterestedTab job={selectedJob} />,
    <SubmittedTab />,
    <InterviewsTab />,
    <StatusTab />,
    // <NotesTab />
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "calc(100vh - 73px)", overflow: "hidden", mt: 1, mx: { xs: -1, md: -1 } }}>
      <Box sx={{ pb: 1, flexShrink: 0 }}>
        <Paper elevation={2} sx={{ borderRadius: '5px' }}>
          <Box sx={{ display: "flex", backgroundColor: "#FFF", justifyContent: "space-between" }}>
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant={isMobileSmall || isMobile ? "scrollable" : "fullWidth"} // Change layout for small devices
              scrollButtons={isMobileSmall || isMobile ? "auto" : false} // Enable scroll buttons for small devices
              sx={{
                minHeight: isMobileSmall ? 36 : 48, // Adjust height for very small devices
                '& .MuiTabs-flexContainer': {
                  flexDirection: isMobileSmall ? "column" : "row", // Stack tabs vertically on very small devices
                },
              }}
            >
              <Tab
                label="All"
                sx={{
                  fontSize: isMobileSmall ? "0.7rem" : "0.875rem", // Smaller font for very small devices
                  padding: isMobileSmall ? "6px" : "12px", // Adjust padding
                  textTransform: "none"
                }}
              />
              <Tab
                label="Interested"
                sx={{
                  fontSize: isMobileSmall ? "0.7rem" : "0.875rem",
                  padding: isMobileSmall ? "6px" : "12px",
                  textTransform: "none"
                }}
              />
              <Tab
                label="Submitted"
                sx={{
                  fontSize: isMobileSmall ? "0.7rem" : "0.875rem",
                  padding: isMobileSmall ? "6px" : "12px",
                  textTransform: "none"
                }}
              />
              <Tab
                label="Interviews"
                sx={{
                  fontSize: isMobileSmall ? "0.7rem" : "0.875rem",
                  padding: isMobileSmall ? "6px" : "12px",
                  textTransform: "none"
                }}
              />
              <Tab
                label="Status"
                sx={{
                  fontSize: isMobileSmall ? "0.7rem" : "0.875rem",
                  padding: isMobileSmall ? "6px" : "12px",
                  textTransform: "none"
                }}
              />
              {/* <Tab
                label="Notes"
                sx={{
                  fontSize: isMobileSmall ? "0.7rem" : "0.875rem",
                  padding: isMobileSmall ? "6px" : "12px",
                }}
              /> */}
            </Tabs>


            <Typography variant='body1' style={{ marginRight: "12px", marginTop: "12px", fontWeight: '700', color: "rgba(0, 0, 0, 0.6)" }}>
              {/* {
                                primaryResumeDetails?.first_name + primaryResumeDetails?.last_name 
                            } - {primaryResumeDetails?.application_title}  */}
              <Box sx={{ display: primaryResumeDetails ? "block" : "none" }}>
                <Breadcrumbs separator="" aria-label="breadcrumb">
                  <p
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      fontSize: "1.0rem"
                    }}
                  >
                    {/* #{primaryResumeDetails?.id} */}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      fontSize: "1.0rem"
                    }}
                  >
                    {/* {primaryResumeDetails?.full_name} */}

                  </p>
                  {/* <p
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      fontSize: "1.0rem"
                    }}
                  >
                     {primaryResumeDetails?.application_title}
                    
                  </p> */}
                  {/* <p
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      fontSize: "1.0rem"
                    }}
                  >
                    {primaryResumeDetails?.is_remote === 1
                      ? "Remote"
                      : primaryResumeDetails?.cityname !== null &&
                        primaryResumeDetails?.cityname !== undefined &&
                        primaryResumeDetails?.statename !== null &&
                        primaryResumeDetails?.statename !== undefined
                        ? primaryResumeDetails?.cityname + ", " + primaryResumeDetails?.statename
                        : primaryResumeDetails?.cityname !== null &&
                          primaryResumeDetails?.cityname !== undefined
                          ? primaryResumeDetails?.cityname !== null && primaryResumeDetails?.cityname
                          : primaryResumeDetails?.statename !== null &&
                            primaryResumeDetails?.statename !== undefined
                            ? primaryResumeDetails?.statename
                            : "Remote"}
                  </p> */}
                </Breadcrumbs>


              </Box>
            </Typography>
          </Box>
        </Paper>
      </Box>

      <Box sx={{ flexGrow: 1, minHeight: 0 }}>
        {tabComponents[selectedTab]}
      </Box>
    </Box>
  );
};

export default Candidatejobs;
